import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { queryClient } from "..";
import { AppContext } from "../app-context";
import { ResponseSelector, VehicleData, VehiclesResponse } from "../types";
import { useFiltering } from "../utils/use-filtering";
import { get } from "./getGeneric";

const useSingleVehicleQuery = (id: string) => {

  const [ isLoading, setIsLoading ] = useState(true);
  const [ vehicleData, setVehicleData ] = useState<VehicleData>();
  const [ makeSecondQuery, setMakeSecondQuery] = useState(false);

  const { globalApi } = useContext(AppContext);
  const { getQueryParams } = useFiltering();

  const getSingleVehicle: ResponseSelector<VehiclesResponse, VehicleData> = (res: VehiclesResponse) => (res?.data as VehicleData[])?.find(x => x.vin === id || x.stock_number === id) as VehicleData;

  if (isLoading) {
    const searchParams = getQueryParams("vehicles", {returnString: true, useApplied: true});
    const vehiclesData = queryClient.getQueryData(["vehicles", searchParams]) as VehiclesResponse;
    const data = getSingleVehicle(vehiclesData);
    setVehicleData(data);
    setIsLoading(false);
  }

  useEffect(() => {
    if (!isLoading && !vehicleData) {
      setMakeSecondQuery(true);
    }
  }, [isLoading, vehicleData]);

  const params = id?.length === 17 ? `vin=${id}` : `source=${id}`;
  const url = `${globalApi}/inventory-app/vehicles?${params}`;

  const secondQuery = useQuery({
    queryKey: ['single-vehicle', params],
    queryFn: () => get<VehiclesResponse>(url),
    select: getSingleVehicle,
    enabled: makeSecondQuery
  });

  return vehicleData ? { isLoading, data: vehicleData } : secondQuery;
};

export default useSingleVehicleQuery;
